<div class="access-restricted">
  <h2 class="title">Access Restricted: {{ header }}</h2>

  <p class="description">
    <strong>Site specific functions</strong> are available in a higher subscription tier.
    <br>
      Please upgrade your site's subscription to unlock this feature.
    </p>

    <div class="billing-section">
      <p class="billing-label">Please contact site's Billing Admin:</p>

      <div class="admins-list">
        @for (admin of billingAdmins; track admin) {
          <div class="admin-item">
            <span class="admin-info">
              {{ admin?.firstName + " " + admin?.lastName }} ({{ admin?.emailId }})
            </span>
          </div>
        }
      </div>

      <div class="contact-actions">
        <a [href]="emailContent">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M20.9105 9.69354C21.0554 9.587 21.2727 9.69354 21.2727 9.87109V17.1154C21.2727 18.0742 20.4759 18.82 19.5341 18.82H4.46593C3.48795 18.82 2.72729 18.0742 2.72729 17.1154V9.87109C2.72729 9.69354 2.9084 9.587 3.05329 9.69354C3.88639 10.3327 4.93681 11.114 8.63141 13.7418C9.39207 14.2745 10.696 15.4464 12 15.4464C13.2678 15.4464 14.608 14.2745 15.3324 13.7418C19.027 11.114 20.0774 10.3327 20.9105 9.69354ZM12 14.2745C11.1307 14.31 9.93539 13.2447 9.31962 12.8185C4.50215 9.40945 4.13994 9.08984 3.05329 8.23757C2.83596 8.09553 2.72729 7.84695 2.72729 7.56286V6.88814C2.72729 5.96484 3.48795 5.18359 4.46593 5.18359H19.5341C20.4759 5.18359 21.2727 5.96484 21.2727 6.88814V7.56286C21.2727 7.84695 21.1279 8.09553 20.9105 8.23757C19.8239 9.08984 19.4617 9.40945 14.6442 12.8185C14.0284 13.2447 12.8331 14.31 12 14.2745Z"
              fill="currentColor" />
          </svg>
        </a>
      </div>
    </div>
  </div>